let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kno0B")).then(() => parcelRequire('8v3BF'));